import React from "react";
import { Grid, InputLabel, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    border: `1px solid ${(theme.vars || theme)?.palette?.primary?.main}`,
    borderRadius: "var(--radius-control)",
    backgroundColor: (theme.vars || theme).palette.background.paper,
    "& fieldset": {
      border: "none",
    },
    "& .MuiInputBase-input": {
      fontSize: ".8rem",
      padding: "11px 11px",
    },
  },
}));

const StyledInputLabel = styled(InputLabel)(() => ({
  fontWeight: 600,
  color: "var(--neutral-700)",
  fontSize: ".92rem",
  transform: "none",
  position: "relative",
  marginBottom: 8,
}));

const FormGroup = styled("div")(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

function NumberRangeMDInputFormik({
  label,
  field,
  form: { touched, errors, setFieldValue },
  ...rest
}: {
  label?: React.ReactNode;
  field: {
    name: string;
    value?: {
      min?: number | string;
      max?: number | string;
    };
  };
  form: {
    touched: Record<string, boolean | undefined>;
    errors: Record<string, { min?: React.ReactNode; max?: React.ReactNode }>;
    setFieldValue: (_name: string, _value: unknown) => void;
  };
  required?: boolean;
}) {
  const fieldErrors = touched[field.name] && errors[field.name];

  const handleChange =
    (type: "min" | "max") => (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setFieldValue(field.name, {
        ...field.value,
        [type]: value ? Number(value) : "",
      });
    };

  return (
    <FormGroup>
      <StyledInputLabel
        shrink
        margin="dense"
        disableAnimation
        required={rest?.required}
      >
        {label}
      </StyledInputLabel>
      <Grid container spacing={2}>
        <Grid
          size={{
            xs: 6,
          }}
        >
          <StyledTextField
            fullWidth
            type="number"
            value={field.value?.min || ""}
            onChange={handleChange("min")}
            variant="outlined"
            error={Boolean(fieldErrors?.min)}
            helperText={fieldErrors?.min}
            InputProps={{
              sx: {
                fontSize: ".8rem",
                padding: "11px 14px",
                height: "auto",
              },
            }}
            InputLabelProps={{
              shrink: true,
              sx: {
                transform: "none",
                position: "relative",
                marginBottom: 1,
              },
            }}
          />
        </Grid>
        <Grid
          size={{
            xs: 6,
          }}
        >
          <StyledTextField
            fullWidth
            type="number"
            value={field.value?.max || ""}
            onChange={handleChange("max")}
            variant="outlined"
            error={Boolean(fieldErrors?.max)}
            helperText={fieldErrors?.max}
            InputProps={{
              sx: {
                fontSize: ".8rem",
                padding: "11px 14px",
                height: "auto",
              },
            }}
            InputLabelProps={{
              shrink: true,
              sx: {
                transform: "none",
                position: "relative",
                marginBottom: 1,
              },
            }}
          />
        </Grid>
      </Grid>
    </FormGroup>
  );
}

export default NumberRangeMDInputFormik;
